import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pulse-bottom" }
const _hoisted_2 = {
  key: 0,
  class: "pulse-atend delay-in-1000"
}
const _hoisted_3 = {
  key: 1,
  ref: "loader",
  class: "loader-block row-hvcenter"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Divider = _resolveComponent("Divider")
  const _component_Loader = _resolveComponent("Loader")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.atend)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Divider, {
            class: "divider",
            bg: "#dcdfe6"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text" }, " No more items ", -1 /* HOISTED */)),
          _createVNode(_component_Divider, {
            class: "divider",
            bg: "#dcdfe6"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          ($props.loading)
            ? (_openBlock(), _createBlock(_component_Loader, {
                key: 0,
                inline: "",
                medium: "",
                "z-index": 1
              }))
            : _createCommentVNode("v-if", true)
        ], 512 /* NEED_PATCH */))
  ]))
}